<template>
  <div>
    <div
      v-if="
        data.deliveryWay === '3' && !data.advanceSale
      "
      class="delivery"
    >
      <span>
        {{
          data.goodsLogistics.advanceTime
        }}
        <!-- {{
          new Date().getHours() < data.cutOffTimeStr.split(":")[0]
            ? `${data.cutOffTimeStr}前（含${data.cutOffTimeStr})下单，可选今日发货`
            : `${data.cutOffTimeStr}后下单，可选次日起发货`
        }} -->
      </span>
    </div>

    <div
      v-if="
        data.deliveryWay === '1' && !data.advanceSale
      "
      class="delivery"
    >
      <span>
        {{
          data.goodsLogistics.advanceTime
        }}
        <!-- {{
          getPrecisionDeliveryText(
            data.preciseDeliveryDay,
            data.preciseDeliveryConfig,
            data.earliestDeliveryTime,
            data.cutOffTimeStr
          )
        }} -->
      </span>
    </div>
  </div>
</template>
<script>

import {
  getHourTime,
  getNextDay,
  plusZero,
} from "@utils";
export default {
  name: "OldHtmlDetailPart",
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {
    /**
     * 精准配送截单时间和最早发货日期
     * @param { Number } preciseDeliveryDay  提前时间 0当天  1明天
     * @param { Array } preciseDeliveryConfig  配送时间段
     * @param { String } preciseDeliveryConfig  可选最早发货时间
     * @param { String } cutOffTimeStr  截单时间
     */
    getPrecisionDeliveryText(
      preciseDeliveryDay,
      preciseDeliveryConfig,
      earliestDeliveryTime,
      cutOffTimeStr
    ) {
      const nowTime = new Date().getTime();
      const deadlineDate =
        new Date().toLocaleDateString() + " " + cutOffTimeStr;
      const deadlineTime = new Date(deadlineDate).getTime();
      const lastHour = preciseDeliveryConfig[preciseDeliveryConfig.length - 1]; // 可选最后时间段
      const lastTime = getHourTime(new Date().toLocaleDateString(), lastHour);
      if (+preciseDeliveryDay > 1) {
        //大于明天
        return nowTime > deadlineTime
          ? `${cutOffTimeStr}${this.TLang('后下单可选', 'my')}${getNextDay(
              earliestDeliveryTime
            )}${this.TLang('起发货的', 'my')}` 
          : `${cutOffTimeStr}${this.TLang('前', 'my')}(${this.TLang('含', 'my')}${cutOffTimeStr})${this.TLang('下单可选', 'my')}${earliestDeliveryTime}${this.TLang('当起发货', 'my')}`;
      }

      if (+preciseDeliveryDay === 1) {
        //明天
        return nowTime > deadlineTime
          ? `${cutOffTimeStr}${this.TLang('后下单可选', 'my')}${getNextDay(
              earliestDeliveryTime
            )}${this.TLang('起发货的', 'my')}`
          : `${cutOffTimeStr}${this.TLang('前', 'my')}(${this.TLang('含含', 'my')}${cutOffTimeStr})${this.TLang('下单可选次日起发货', 'my')}`;
      }

      //今天
      if (nowTime > deadlineTime)
        return `${cutOffTimeStr}${this.TLang('后下单可选次日起发货', 'my')}`; //过了截单时间
      if (lastTime - 3 * 60 * 60 * 1000 >= deadlineTime)
        return `${cutOffTimeStr}${this.TLang('前', 'my')}(${this.TLang('含含含', 'my')}${cutOffTimeStr})${this.TLang('第二个下单可选今日发货', 'my')}`;
      const allowDay = new Date(lastTime - 3 * 60 * 60 * 1000);
      const allowTime =
        plusZero(allowDay.getHours()) + ":" + plusZero(allowDay.getMinutes());
      return `${allowTime}${this.TLang('第二个后下单可选次日起发货', 'my')}`;
    },
  },
};
</script>
<style lang="less" scoped>
.delivery {
  line-height: 30px;
  margin-left: 42px;
  margin-bottom: 10px;
  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }
  img.pre-tag {
    width: 36px;
    height: 20px;
  }
  span {
    font-size: 14px;
    color: #666;
  }
}
</style>
